<template>
  <div class="highlights">

    <!-- Hero -->
    <section class="hero-section">
      <div class="hero-inner">
        <h1 class="hero-title">项目亮点</h1>
        <p class="hero-desc">
          <span class="block">不管您选择的是 <span class="highlight">成品项目</span> 还是 <span class="highlight">定制开发</span></span>
         <br/> <span class="block">我们均支持亮点功能的灵活叠加，让项目更出彩、更具竞争力！</span>
        </p>
      </div>
    </section>

    <!-- 亮点功能卡片 -->
    <section class="section bg-gray">
      <div class="section-inner">
        <!-- 筛选 + 搜索 -->
        <div class="toolbar">
          <div class="filter-tags">
            <button
              v-for="tab in tabs"
              :key="tab.name"
              :class="['filter-btn', activeCategory === tab.name ? 'active' : '']"
              @click="activeCategory = tab.name; loadItems()"
            >{{ tab.label }}</button>
          </div>
          <div class="search-wrap">
            <input v-model="keyword" type="text" placeholder="亮点名称..." class="search-input" @keyup.enter="handleSearch" />
            <svg class="search-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/>
            </svg>
          </div>
        </div>

        <!-- 加载中 -->
        <div v-if="loading" class="loading-wrap">
          <el-skeleton :rows="3" animated />
        </div>

        <!-- 卡片列表 -->
        <div v-else>
          <div class="card-grid" v-if="filteredItems.length > 0">
            <div class="card" v-for="item in filteredItems" :key="item.id" @click="showDetail(item)">
              <div class="card-top">
                <img :src="item.coverPath" :alt="item.name" class="card-img" />
                <div class="card-meta">
                  <h3 class="card-title">{{ item.name }}</h3>
                  <span class="card-tag">{{ item.type }}</span>
                </div>
              </div>
              <p class="card-desc">{{ item.description }}</p>
            </div>
          </div>
          <el-empty v-else description="暂无数据" />
        </div>
      </div>
    </section>

    <!-- 详情抽屉 -->
    <el-drawer
      :visible.sync="drawerVisible"
      :title="currentItem.name"
      :size="drawerSize"
      direction="rtl"
      :destroy-on-close="true"
    >
      <div class="drawer-content">
        <mavon-editor
          v-model="currentItem.details"
          :subfield="false"
          default-open="preview"
          :toolbarsFlag="false"
          :editable="false"
          :scrollStyle="true"
          :ishljs="true"
          :boxShadow="false"
          preview-background="#fff"
          class="md-editor"
        />
      </div>
    </el-drawer>

  </div>
</template>

<script>
export default {
  name: 'Highlights',
  data() {
    return {
      loading: false,
      items: [],
      keyword: '',
      activeCategory: 'all',
      drawerVisible: false,
      currentItem: {},
      windowWidth: window.innerWidth,
      tabs: [
        { name: 'all', label: '全部' },
        { name: 'advanced', label: '高级亮点' },
        { name: 'text', label: '文字识别' },
        { name: 'image', label: '图片识别' },
      ]
    }
  },
  computed: {
    filteredItems() {
      return this.items || []
    },
    drawerSize() {
      return this.windowWidth <= 768 ? '100%' : '50%'
    }
  },
  watch: {
    keyword() {
      clearTimeout(this._searchTimer)
      this._searchTimer = setTimeout(() => { this.loadItems() }, 400)
    }
  },
  created() {
    this.increasePageView()
    this.loadItems()
  },
  mounted() {
    window.addEventListener('resize', () => { this.windowWidth = window.innerWidth })
  },
  methods: {
    increasePageView() {
      this.request.get('/pageView/increase', {
        params: { pageName: 'highlights' }
      }).catch(() => {})
    },
    async loadItems() {
      this.loading = true
      try {
        const typeMap = { advanced: '高级亮点', text: '文字识别', image: '图片识别' }
        const params = {}
        if (this.keyword) params.name = this.keyword
        if (this.activeCategory !== 'all') params.type = typeMap[this.activeCategory]
        const res = await this.request.get('/highlights/getFrontHighlightsList', { params })
        if (res.code === '200') {
          this.items = (res.data || []).filter(item => item.status === 1)
        }
      } catch (e) {
        this.$message.error('加载失败，请稍后重试')
      } finally {
        this.loading = false
      }
    },
    handleSearch() {
      this.loadItems()
    },
    showDetail(item) {
      this.currentItem = item
      this.drawerVisible = true
    }
  }
}
</script>

<style scoped>
.highlights { background: #fff; }

/* Hero */
.hero-section {
  background: #fff;
  background-image: linear-gradient(to right, #f0f0f0 1px, transparent 1px),
    linear-gradient(to bottom, #f0f0f0 1px, transparent 1px);
  background-size: 20px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  min-height: 300px;
}

.hero-inner {
  max-width: 896px;
  margin: 0 auto;
  text-align: center;
}

.hero-title {
  font-size: 36px;
  font-weight: 900;
  color: #4f46e5;
  margin: 0 0 32px;
}

@media (min-width: 768px) { .hero-title { font-size: 48px; } }

.hero-desc {
  font-size: 18px;
  color: #4b5563;
  line-height: 1.75;
  margin: 0;
}

.highlight {
  color: #2563eb;
  font-weight: 700;
}

/* 通用 */
.section { padding: 32px 0 48px; }
.bg-gray { background: #f9fafb; }

.section-inner {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 20px;
}

@media (min-width: 768px) { .section-inner { padding: 0 32px; } }

/* 工具栏 */
.toolbar {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 32px;
}

@media (min-width: 768px) {
  .toolbar { flex-direction: row; justify-content: space-between; align-items: center; }
}

.filter-tags { display: flex; flex-wrap: wrap; gap: 12px; }

.filter-btn {
  padding: 8px 16px;
  font-size: 14px;
  border: 1px solid #e5e7eb;
  background: #fff;
  color: #374151;
  cursor: pointer;
  transition: all 0.2s;
}

.filter-btn:hover { border-color: #3b82f6; }
.filter-btn.active { background: #2563eb; color: #fff; border-color: #2563eb; }

.search-wrap {
  position: relative;
  width: 100%;
}

@media (min-width: 768px) { .search-wrap { width: 320px; } }

.search-input {
  width: 100%;
  padding: 8px 40px 8px 16px;
  border: 1px solid #e5e7eb;
  font-size: 14px;
  outline: none;
  box-sizing: border-box;
  transition: border-color 0.2s;
}

.search-input:focus { border-color: #3b82f6; }

.search-icon {
  width: 20px;
  height: 20px;
  color: #9ca3af;
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
}

.loading-wrap { padding: 40px 0; }

/* 卡片 */
.card-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
}

@media (min-width: 768px) { .card-grid { grid-template-columns: 1fr 1fr; } }
@media (min-width: 1024px) { .card-grid { grid-template-columns: repeat(4, 1fr); } }

.card {
  background: #fff;
  border: 1px solid #e5e7eb;
  padding: 24px;
  transition: border-color 0.2s;
  cursor: pointer;
}

.card:hover { border-color: #3b82f6; }

.card-top {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 16px;
}

.card-img {
  width: 60px;
  height: 60px;
  object-fit: contain;
  flex-shrink: 0;
  border-radius: 6px;
}

.card-meta {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 6px;
}

.card-title {
  font-size: 16px;
  font-weight: 600;
  color: #2563eb;
  margin: 0;
  line-height: 1.3;
  transition: color 0.2s;
}

.card:hover .card-title { color: #1d4ed8; }

.card-tag {
  display: inline-flex;
  padding: 2px 8px;
  background: #f0fdf4;
  color: #16a34a;
  font-size: 13px;
  align-self: flex-start;
}

.card-desc {
  font-size: 14px;
  color: #4b5563;
  line-height: 1.625;
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* 抽屉 */
.drawer-content { padding: 20px; }
.md-editor { width: 100%; }
</style>
